(function ($, Drupal, once) {
  'use strict';

  const dev = false; // true | false
  const highestLiAddAmt = 10;
  const menuTitle_0 = 'div.field--name-field-menu-text-block';
  const menuDropDown_0 = 'div.menu-dropdown-0';
  const cssJSON = {height: '0', padding: '0', overflow: 'hidden'};
  const fadeClass = 'bbfade';
  const fadeClassAll = 'bb-fade--all';
  const highlightClass = 'highlight';
  const menuOffDelay = 300;
  const menuOnDelay = 175;
  const checkMouseStatusDelay = 300;

  function getSubmenus() {
    return $(`.region-header ul.menu-level-0 li.menu-item ${menuDropDown_0}`);
  }

  function getNavLinks() {
    return $('.region-header ul.menu-level-0 li.menu-item--expanded a');
  }

  Drupal.behaviors.desktopMegaMenu = {
    attach: function (context) {
      window.menuPartHideClass = window.menuPartHideClass || 'hidden-mm';

      // Hide dropdowns as they appear (including BigPipe replacements).
      $(once('desktop-megamenu-hide', `.region-header ${menuDropDown_0}`, context))
        .addClass(fadeClass)
        .css(cssJSON);
      $(once('desktop-megamenu-fade-links', '.region-header ul.menu-level-0 li.menu-item--expanded a', context))
        .addClass(fadeClassAll);

      if (!once('desktop-megamenu', 'html').length) {
        return;
      }

      let minimizeElementsTimeout = '';
      let turnMouseFalseTimeOut = '';
      let turnMouseTrueTimeOut = '';
      let mouseOnMenu = false;
      let highestLi = 0;

      function mouseOverCommon() {
        clearTimeout(minimizeElementsTimeout);
        clearTimeout(turnMouseFalseTimeOut);
      }

      function mouseOutCommon() {
        clearTimeout(turnMouseTrueTimeOut);
        turnMouseFalseTimeOut = setTimeout(function () {
          mouseOnMenu = false;
        }, menuOffDelay);
      }

      function setUlHeight($this) {
        highestLi = 0;
        $this.siblings(menuDropDown_0).find('ul.menu-level-1 > li.menu-item').attr('style', '');
        $this.siblings(menuDropDown_0).find('ul.menu-level-1 > li.menu-item').each(function () {
          if ($(this).height() + highestLiAddAmt > highestLi + highestLiAddAmt) {
            highestLi = $(this).height() + highestLiAddAmt;
          }
        });
        $this.siblings(menuDropDown_0).find('ul.menu-level-1 > li.menu-item').css('height', highestLi);
      }

      function menuContainerChangeWidth($exists, $this) {
        if ($exists) {
          let newWidth = 1240;

          if (window.innerWidth <= 1240) {
            newWidth = window.innerWidth * 0.95;
          }

          $this.siblings(menuDropDown_0).css('width', newWidth);
        }
      }

      $(document).on('mouseenter', '.region-header ul.menu-level-0 > li.menu-item > a', function () {
        const $this = $(this);
        const headerSubmenuDomPath = getSubmenus();
        const navLinks = getNavLinks();
        navLinks.removeClass(highlightClass);
        $('.region-header ul.menu-level-0 li.menu-item a').removeClass(highlightClass);
        mouseOnMenu = true;

        mouseOverCommon();
        $this.addClass(highlightClass);

        turnMouseTrueTimeOut = setTimeout(function () {
          headerSubmenuDomPath.addClass(window.menuPartHideClass);
          headerSubmenuDomPath.attr('aria-hidden', 'true');
          headerSubmenuDomPath.find(menuTitle_0).addClass(window.menuPartHideClass);

          $this.siblings(menuDropDown_0).attr('style', '');
          $this.siblings(menuDropDown_0).attr('aria-hidden', 'false');
          headerSubmenuDomPath.find('ul.menu-level-1').attr('style', '');
          $this.siblings(menuDropDown_0).removeClass(window.menuPartHideClass);
          $this.siblings(menuDropDown_0).find('ul').removeClass(window.menuPartHideClass);
          $this.siblings(menuDropDown_0).find(menuTitle_0).removeClass(window.menuPartHideClass);
          setUlHeight($this);

          menuContainerChangeWidth($this.siblings(menuDropDown_0).find('.field--name-field-mega-menu-accent-image img').length, $this);
        }, menuOnDelay);
      });

      $(document).on('mouseleave', '.region-header ul.menu-level-0 > li.menu-item > a', function () {
        mouseOutCommon();
      });

      $(document).on('mouseenter', `.region-header ${menuDropDown_0}`, function () {
        mouseOnMenu = true;
        turnMouseTrueTimeOut = setTimeout(function () {
          mouseOnMenu = true;
          mouseOverCommon();
        }, menuOnDelay);
      });

      $(document).on('mouseleave', `.region-header ${menuDropDown_0}`, function () {
        mouseOutCommon();
        mouseOnMenu = false;
      });

      if (dev === false) {
        setInterval(() => {
          if (mouseOnMenu === false) {
            const headerSubmenuDomPath = getSubmenus();
            getNavLinks().removeClass(highlightClass);
            headerSubmenuDomPath.addClass(window.menuPartHideClass);
            minimizeElementsTimeout = setTimeout(function () {
              headerSubmenuDomPath.css(cssJSON);
              headerSubmenuDomPath.attr('aria-hidden', 'true');
              headerSubmenuDomPath.find('ul.menu-level-1').css(cssJSON);
            }, 400);
          }
        }, checkMouseStatusDelay);
      }
    }
  };
})(jQuery, Drupal, once);
